import React from 'react';

import * as ArchiveActions from 'archive/ArchiveActions';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import {NavStoreRegistry} from 'constants/RegistryConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import licenses from 'user/Licenses';

export interface DeleteOrArchiveRegistryButtonProps {
  onDelete?: () => void;
  registry: NavStoreRegistry;
}

/**
 * Render 'Archive Registry' button that opens ArchiveModal.
 *
 * Hide button from enterprise users and registry non-admins. For enterprise users, we don't want to make
 * archiving user-friendly. They should go through support to archive their registry.
 */
class DeleteOrArchiveRegistryButton extends React.Component<DeleteOrArchiveRegistryButtonProps> {
  private canDelete = (): boolean => {
    const hasDeleteAuth = RegistryUtil.hasSettingsAccess(this.props.registry);
    const isAcademicUser = !licenses.hasEnterprisePlan();
    return hasDeleteAuth && isAcademicUser;
  };

  private handleOpenArchiveModal = (): void => {
    ArchiveModal.open({items: [this.props.registry], onArchive: ArchiveActions.bulkArchiveRegistries});
  };

  override render(): JSX.Element | null {
    if (!this.canDelete()) {
      return null;
    }
    return (
      <Button
        buttonStyle={ButtonStyle.NEGATIVE}
        onClick={this.handleOpenArchiveModal}
        size={ButtonSize.MEDIUM}
        text="Archive Registry"
      />
    );
  }
}

export default DeleteOrArchiveRegistryButton;
